import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-footer',
  imports: [NgxTolgeeModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  /** Copyright year, so the notice cannot go stale in the markup. */
  readonly currentYear = new Date().getFullYear();

  constructor(private router: Router) {
  }

  public goTo(page: string) {
    this.router.navigate([`/${page}`]);
  }

  /** Sections live on the home page, so land there and let it scroll into place */
  public goToSection(sectionId: string) {
    this.router.navigate(['/'], { queryParams: { scrollTo: sectionId } });
  }
}
